const WORD_COLORS = ['#059669', '#2563eb', '#9333ea', '#b45309', '#0891b2', '#be185d'];
function resultWordRange(word, size) {
  let cells = word?.cells;
  if (!Array.isArray(cells) || !cells.length) {
    let { axis, lineIndex, start, end } = word || {};
    if (!['row', 'col'].includes(axis) || ![lineIndex, start, end].every(Number.isInteger)) {
      const match = String(word?.type || '').match(/(satır|yatay|sütun|düşey|dikey)\s+(\d+)\s*\((\d+)-(\d+)\)/i);
      if (!match) return null;
      axis = /satır|yatay/i.test(match[1]) ? 'row' : 'col';
      lineIndex = Number(match[2]) - 1; start = Number(match[3]) - 1; end = Number(match[4]);
    }
    if (lineIndex < 0 || lineIndex >= size || start < 0 || end > size || end - start < 2) return null;
    cells = Array.from({ length: end - start }, (_, i) => axis === 'row'
      ? { row: lineIndex, col: start + i } : { row: start + i, col: lineIndex });
  }
  if (cells.length < 2 || cells.some(cell => !Number.isInteger(cell.row) || !Number.isInteger(cell.col) || cell.row < 0 || cell.col < 0 || cell.row >= size || cell.col >= size)) return null;
  const rows = cells.map(cell => cell.row), cols = cells.map(cell => cell.col);
  const top = Math.min(...rows), bottom = Math.max(...rows), left = Math.min(...cols), right = Math.max(...cols);
  const unique = new Set(cells.map(cell => `${cell.row}:${cell.col}`));
  if (unique.size !== cells.length || (top !== bottom && left !== right) || (bottom - top + 1) * (right - left + 1) !== cells.length) return null;
  return { top, bottom, left, right, cells };
}
function nextWordAtCell(words, size, row, col, selected) {
  const hits = words.map((word, index) => ({ index, range: resultWordRange(word, size) }))
    .filter(({ range }) => range?.cells.some(cell => cell.row === row && cell.col === col)).map(item => item.index);
  if (!hits.length || (hits.length === 1 && hits[0] === selected)) return null;
  const current = hits.indexOf(selected);
  return hits[(current + 1) % hits.length];
}
module.exports = { WORD_COLORS, resultWordRange, nextWordAtCell };
